module.exports = __webpack_public_path__ + "media/07_ASANBudapest-Custom07.d6e576e7.mp3";